import * as React from "react";
import IPaperEmbed, { IPaperEmbedProps } from "~/components/ipaper-embed/ipaper-embed";

export interface IPaperEmbedViewProps {
    contextModel: IPaperEmbedProps;
}

class IPaperEmbedView extends React.PureComponent<IPaperEmbedViewProps> {
    public render() {
        return <IPaperEmbed {...this.props.contextModel} />;
    }
}

export default IPaperEmbedView;
